export const appointmentData = [
    {
      id: 1,
      patient: "Barry Vermont",
      day: new Date(),
      consulted: true,
      doctor: "Dr. Hazel Valery",
    },
    {
      id: 2,
      patient: "Harry Coming",
      day: new Date(),
      consulted: false,
      doctor: "Dr. Jessica White",
    },
    {
      id: 3,
      patient: "Aaron Black",
      day: new Date(),
      consulted: true,
      doctor: "Dr. Jasmine Carpanter",
    },
  ]
  
  export const doctorData = [
    {
      id: 1,
      name: "Dr.Hazel Valery",
      dep: "Cardiology",
      img: "https://images.unsplash.com/photo-1527613426441-4da17471b66d?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w1NzUyMDl8MHwxfHNlYXJjaHwzfHxkb2N0b3JzfGVufDB8fHx8MTcxMTUxNjIzMHww&ixlib=rb-4.0.3&q=80&w=400",
    },
    {
      id: 2,
      name: "Dr. Jasmine Carpanter",
      dep: "Radiolgy",
      img: "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w1NzUyMDl8MHwxfHNlYXJjaHw4fHxkb2N0b3J8ZW58MHx8fHwxNzExNTE0NTcxfDA&ixlib=rb-4.0.3&q=80&w=400",
    },
    {
      id: 3,
      name: "Dr. Sean Mary",
      dep: "Orthopedy",
      img: "https://images.unsplash.com/photo-1537368910025-700350fe46c7?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w1NzUyMDl8MHwxfHNlYXJjaHw2fHxkb2N0b3J8ZW58MHx8fHwxNzExNTE0NTcxfDA&ixlib=rb-4.0.3&q=80&w=400",
    },
    {
      id: 4,
      name: "Dr. Jessica White",
      dep: "Gastroentogoly",
      img: "https://images.unsplash.com/photo-1651008376811-b90baee60c1f?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w1NzUyMDl8MHwxfHNlYXJjaHwxfHxkb2N0b3J8ZW58MHx8fHwxNzExNTE0NTcxfDA&ixlib=rb-4.0.3&q=80&w=400",
    },
    {
      id: 5,
      name: "Harry Coming",
      dep: "Surgery",
      img: "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w1NzUyMDl8MHwxfHNlYXJjaHw0fHxkb2N0b3J8ZW58MHx8fHwxNzExNTE0NTcxfDA&ixlib=rb-4.0.3&q=80&w=400",
    },
    {
      id: 6,
      name: "Dr. Noah Abraham",
      dep: "Neurology",
      img: "https://images.unsplash.com/photo-1622253692010-333f2da6031d?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w1NzUyMDl8MHwxfHNlYXJjaHw5fHxkb2N0b3JzfGVufDB8fHx8MTcxMTUxNjIzMHww&ixlib=rb-4.0.3&q=80&w=400",
    },
    {
      id: 7,
      name: "Dr.Will Graham",
      dep: "Pediatry",
      img: "https://images.unsplash.com/photo-1667133295308-9ef24f71952e?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w1NzUyMDl8MHwxfHNlYXJjaHwxfHxkZW50aXN0fGVufDB8fHx8MTcxMTUxNjI2OHww&ixlib=rb-4.0.3&q=80&w=400",
    },
    {
      id: 8,
      name: "Dr. Mark Motley",
      dep: "Oncology",
      img: "https://images.unsplash.com/photo-1576669801775-ff43c5ab079d?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w1NzUyMDl8MHwxfHNlYXJjaHw5fHxtYWxlJTIwZG9jdG9yfGVufDB8fHx8MTcxMTUxNjMyNHww&ixlib=rb-4.0.3&q=80&w=400",
    },
  ]